export const SUBMIT_UPDATE_PASSWORD_REQUEST_SUCCESS = "SUBMIT_UPDATE_PASSWORD_REQUEST_SUCCESS"